import React from "react";

import Script from "dangerous-html/react";
import { Helmet } from "react-helmet";

import Navigation from "../components/navigation";
import Footer from "../components/footer";
import "./home.css";

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>MDMC.dev</title>
        <meta property="og:title" content="MDMC.dev" />
        <link rel="canonical" href="https://mdmc.dev/" />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-video-wrapper">
          <video
            src="https://videos.pexels.com/video-files/4990248/4990248-hd_1920_1080_30fps.mp4"
            loop="true"
            muted="true"
            autoPlay="true"
            playsInline="true"
            className="hero-video-bg"
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-wrapper">
          <div className="hero-text-container">
            <h1 className="hero-title home-hero-title">COLLIDE THE DANKNESS</h1>
            <p className="home-hero-subtitle hero-subtitle">
              Welcome to MDMC.dev — The Massive Dank Meme Collider. Where
              internet history is smashed together to create the future of
              humor.
            </p>
            <div className="hero-alert">
              <span className="hero-alert-badge">LIVE</span>
              <span>Collider hits spiking — lock your access now.</span>
            </div>
            <div className="hero-cta-group">
              <a href="/meme-generator">
                <div className="btn btn-primary btn-lg">
                  <span>MAKE A MEME — FREE</span>
                </div>
              </a>
              <a href="/library">
                <div className="btn btn-lg btn-secondary">
                  <span>READ THE DANK CANON</span>
                </div>
              </a>
              <a href="/output-zone">
                <div className="btn btn-lg btn-secondary">
                  <span>ENTER OUTPUT ZONE</span>
                </div>
              </a>
              <a href="/collider">
                <div className="btn btn-lg btn-accent">
                  <span>ENTER THE LAB</span>
                </div>
              </a>
              <a
                href="https://tinyhost.xyz"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="btn btn-lg btn-outline">
                  <span>HOST YOUR MEMES</span>
                </div>
              </a>
              <a
                href="https://tx.wtf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="btn btn-lg btn-accent">
                  <span>FIND MORE DANKNESS ON TX.WTF</span>
                </div>
              </a>
            </div>
            <form className="hero-capture" data-form-id="mdmc-hero-capture">
              <input
                type="email"
                name="email"
                placeholder="you@signal.com"
                className="hero-input"
                required="true"
              />
              <button className="btn btn-primary" type="submit">
                CLAIM EARLY ACCESS
              </button>
            </form>
          </div>
        </div>
      </section>
      <section className="feature-nav-section">
        <div className="feature-scroll-container">
          <a className="feature-item-card" href="/meme-generator">
            <div className="feature-icon-box">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 3v18"></path>
                  <rect x="6" y="3" rx="2" width="12" height="18"></rect>
                  <path d="M22 3v18"></path>
                </g>
              </svg>
            </div>
            <span className="section-content">MAKE A MEME</span>
          </a>
          <a className="feature-item-card" href="/collider">
            <div className="feature-icon-box">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M10 2v6.292a7 7 0 1 0 4 0V2M5 15h14M8.5 2h7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <span className="section-content">COLLIDER LAB</span>
          </a>
          <a
            className="feature-item-card"
            href="https://www.janusmedia.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="feature-icon-box">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                  <circle r="4" cx="9" cy="7"></circle>
                </g>
              </svg>
            </div>
            <span className="section-content">APPLIED RESEARCH</span>
          </a>
          <a
            className="feature-item-card"
            href="https://tinyhost.xyz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="feature-icon-box">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 10a4 4 0 1 1-8 0M3.103 6.034h17.794"></path>
                  <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"></path>
                </g>
              </svg>
            </div>
            <span className="section-content">HOST YOUR MEMES</span>
          </a>
          <div className="feature-counter-card">
            <div className="counter-label">
              <span>TOTAL COLLISIONS</span>
            </div>
            <div id="collisionCounter" className="counter-value">
              <span>4,206,969</span>
            </div>
          </div>
        </div>
      </section>
      <section className="home-library-section">
        <div className="home-library-copy">
          <span className="home-library-kicker">New shelf unlocked</span>
          <h2 className="section-title">Principia Memetica</h2>
          <p>
            A wiki-style research library for meme state vectors, cringe
            resonance, slop collapse, information hydrodynamics, and the
            dangerous math of being funny on purpose.
          </p>
          <div className="home-library-actions">
            <a href="/library" className="btn btn-primary">
              Open Dank Research Library
            </a>
            <a href="/meme-generator" className="btn btn-outline">
              Test Theory In The Meme Generator
            </a>
          </div>
        </div>
        <div className="home-library-card">
          <span>FIELD EQUATION</span>
          <strong>D = F(C, I, R, S)</strong>
          <p>
            Dankness emerges when clarity, irony, recognition, and social timing
            collide without collapsing into pure slop.
          </p>
        </div>
      </section>
      <section className="showcase-section">
        <h2 className="section-title">RECENT COLLISIONS</h2>
        <div className="showcase-carousel-wrapper">
          <div id="showcaseTrack" className="showcase-track">
            <div className="showcase-card">
              <img
                alt="Meme 1"
                src="https://images.pexels.com/photos/6259878/pexels-photo-6259878.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="showcase-img"
              />
              <div className="showcase-info">
                <span className="section-subtitle">Doge x Santa Fusion</span>
                <p className="section-content">By @MemeLord420</p>
                <a className="btn btn-sm btn-outline" href="/output-zone">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <circle r="3" cx="18" cy="5"></circle>
                    <circle r="3" cx="6" cy="12"></circle>
                    <circle r="3" cx="18" cy="19"></circle>
                    <path d="m8.59 13.51l6.83 3.98m-.01-10.98l-6.82 3.98"></path>
                  </svg>
                  <span>
                    {" "}
                    SHARE
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                </a>
              </div>
            </div>
            <div className="showcase-card">
              <img
                alt="Meme 2"
                src="https://images.pexels.com/photos/6940591/pexels-photo-6940591.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="showcase-img"
              />
              <div className="showcase-info">
                <span className="section-subtitle">Neon Void Cat</span>
                <p className="section-content">By @GlitchMaster</p>
                <a className="btn btn-sm btn-outline" href="/output-zone">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <circle r="3" cx="18" cy="5"></circle>
                    <circle r="3" cx="6" cy="12"></circle>
                    <circle r="3" cx="18" cy="19"></circle>
                    <path d="m8.59 13.51l6.83 3.98m-.01-10.98l-6.82 3.98"></path>
                  </svg>
                  <span>
                    {" "}
                    SHARE
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                </a>
              </div>
            </div>
            <div className="showcase-card">
              <img
                alt="Meme 3"
                src="https://images.pexels.com/photos/10220710/pexels-photo-10220710.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="showcase-img"
              />
              <div className="showcase-info">
                <span className="section-subtitle">Balloon Dog Paradox</span>
                <p className="section-content">By @ArtTroll</p>
                <a className="btn btn-sm btn-outline" href="/output-zone">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <circle r="3" cx="18" cy="5"></circle>
                    <circle r="3" cx="6" cy="12"></circle>
                    <circle r="3" cx="18" cy="19"></circle>
                    <path d="m8.59 13.51l6.83 3.98m-.01-10.98l-6.82 3.98"></path>
                  </svg>
                  <span>
                    {" "}
                    SHARE
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                </a>
              </div>
            </div>
            <div className="showcase-card">
              <img
                alt="Meme 4"
                src="https://images.pexels.com/photos/6940274/pexels-photo-6940274.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="showcase-img"
              />
              <div className="showcase-info">
                <span className="section-subtitle">Cyberpunk Shiba</span>
                <p className="section-content">By @FutureDoge</p>
                <a className="btn btn-sm btn-outline" href="/output-zone">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <circle r="3" cx="18" cy="5"></circle>
                    <circle r="3" cx="6" cy="12"></circle>
                    <circle r="3" cx="18" cy="19"></circle>
                    <path d="m8.59 13.51l6.83 3.98m-.01-10.98l-6.82 3.98"></path>
                  </svg>
                  <span>
                    {" "}
                    SHARE
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="lore-section">
        <div className="lore-video-wrapper">
          <video
            src="https://videos.pexels.com/video-files/5680034/5680034-hd_1920_1080_24fps.mp4"
            loop="true"
            muted="true"
            autoPlay="true"
            playsInline="true"
            className="lore-video-bg"
          ></video>
          <div className="lore-overlay"></div>
        </div>
        <div className="lore-content-container">
          <h2 className="hero-title home-hero-title">THE LORE OF THE LAB</h2>
          <p className="section-subtitle">
            &quot;One does not simply walk into the Collider.&quot; — MDMC
            Founder
          </p>
          <div className="lore-captions">
            <div className="caption-item">
              <span>SHENANIGANS DETECTED</span>
            </div>
            <div className="caption-item">
              <span>MAXIMUM DANKNESS ACHIEVED</span>
            </div>
            <div className="caption-item">
              <span>COMMUNITY PEAKING</span>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="about-container">
          <div className="about-card">
            <h2 className="section-title">WHAT IS MDMC?</h2>
            <p className="section-content">
              The Massive Dank Meme Collider (MDMC.dev) is the world&apos;s
              first sub-atomic humor accelerator. We take high-energy internet
              culture, accelerate it to 99% the speed of light, and smash it
              together to see what funny particles fly out.
            </p>
            <p className="section-content">
              Our mission? To achieve a self-sustaining humor reaction that
              powers the internet for the next thousand years. Join the chaos,
              submit your memes, and let&apos;s break the physics of funny.
            </p>
            <div className="about-stats">
              <div className="stat-box">
                <span className="stat-num">1.21</span>
                <span className="stat-label">Gigawatts of Lulz</span>
              </div>
              <div className="stat-box">
                <span className="stat-num">∞</span>
                <span className="stat-label">Dank Potential</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <h2 className="section-title">THEY SAID IT (PROBABLY)</h2>
        <div className="testimonial-carousel-container">
          <div className="testimonial-track">
            <div className="testimonial-card">
              <p className="section-content">
                &quot;I collided a Pepe with a Rickroll and now I can see the
                5th dimension. 10/10 would bang memes again.&quot;
              </p>
              <span className="section-subtitle">— @MemeGod99</span>
            </div>
            <div className="testimonial-card">
              <p className="section-content">
                &quot;Finally, a place where my 3 AM brain rot is treated as
                high-energy physics. MDMC is the future.&quot;
              </p>
              <span className="section-subtitle">— @BrainRotKing</span>
            </div>
            <div className="testimonial-card">
              <p className="section-content">
                &quot;The gear is so dank my mom actually asked if I was okay.
                Mission accomplished.&quot;
              </p>
              <span className="section-subtitle">— @MerchCollector</span>
            </div>
            <div className="testimonial-card">
              <p className="section-content">
                &quot;I don&apos;t know what&apos;s happening but I&apos;m
                laughing and my GPU is on fire. Love it.&quot;
              </p>
              <span className="section-subtitle">— @TechTroll</span>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-section">
        <div className="cta-trigger-container">
          <h2 className="section-title">READY TO COLLIDE?</h2>
          <p className="section-content">
            Request access, test the public tools, or route a client staging
            surface into the showroom.
          </p>
          <button id="openCtaModal" className="btn btn-primary btn-xl">
            JOIN THE CHAOS
          </button>
        </div>
        <dialog id="ctaModal" className="cta-dialog">
          <div className="modal-inner">
            <h2 className="section-title">THE LAB AWAITS</h2>
            <p className="section-content">
              Enter your coordinates and the MDMC intake queue will route you to
              the right public, client, or operator surface.
            </p>
            <form
              action="/submit"
              method="POST"
              data-form-id="fce1253f-6ce8-4ab7-be5a-ad3efa3da046"
              className="cta-form"
            >
              <div className="form-group">
                <input
                  type="email"
                  id="thq_textinput_yuO-"
                  name="textinput"
                  required="true"
                  placeholder="YOUR@EMAIL.COM"
                  data-form-field-id="thq_textinput_yuO-"
                  className="cta-input"
                />
              </div>
              <div className="form-actions">
                <button
                  id="thq_button_M8vb"
                  name="button"
                  type="submit"
                  data-form-field-id="thq_button_M8vb"
                  className="btn btn-lg btn-accent"
                >
                  CLAIM BADGE
                </button>
                <button
                  id="closeCtaModal"
                  name="button"
                  type="button"
                  data-form-field-id="closeCtaModal"
                  className="btn btn-lg btn-outline"
                >
                  LATER, NERD
                </button>
              </div>
            </form>
          </div>
        </dialog>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
        @keyframes scrollShowcase {0% {transform: translateX(0);}
100% {transform: translateX(-50%);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<script defer data-name="mdmc-logic">
(function(){
  const modal = document.getElementById("ctaModal")
  const openBtn = document.getElementById("openCtaModal")
  const closeBtn = document.getElementById("closeCtaModal")
  const counter = document.getElementById("collisionCounter")

  if (openBtn && modal) {
    openBtn.addEventListener("click", () => {
      modal.showModal()
    })
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener("click", () => {
      modal.close()
    })
  }

  if (modal) {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        modal.close()
      }
    })
  }

  setInterval(() => {
    if (counter) {
      let current = parseInt(counter.innerText.replace(/,/g, ""))
      current += Math.floor(Math.random() * 5)
      counter.innerText = current.toLocaleString()
    }
  }, 2000)

  const track = document.getElementById("showcaseTrack")
  if (track) {
    const clone = track.innerHTML
    track.innerHTML += clone
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Home;
